import { createStyles, IconButton, makeStyles, Theme, Typography } from '@material-ui/core';
import CancelIcon from '@material-ui/icons/Cancel';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import CloseIcon from '@material-ui/icons/Close';
import WatchLaterIcon from '@material-ui/icons/WatchLater';
import { FuncaoParticipante, RegistroStatus } from 'common/genericTypes';
import React from 'react';
import { useSelector } from 'react-redux';
import { RootState } from 'store';

const useStyles = (status: RegistroStatus) =>
  makeStyles((theme: Theme) => {
    const colors: { [key: string]: string } = {
      [RegistroStatus.Aprovado]: theme.palette.primary.main,
      [RegistroStatus.Reprovado]: theme.palette.error.main,
      [RegistroStatus.AguardandoCorrecao]: theme.palette.warning.main,
      [RegistroStatus.Excluido]: theme.palette.error.main,
      [RegistroStatus.AguardandoAprovacaoEdicao]: theme.palette.warning.main,
    };

    return createStyles({
      toast: {
        display: 'flex',
        alignItems: 'center',
        backgroundColor: colors[status] ?? theme.palette.grey,
        padding: '8px 80px',
        margin: '0 -80px',
      },
    });
  });

interface StatusToastProps {
  status: RegistroStatus;
  ticket: string;
  onDismiss: () => void;
}

export const StatusToast: React.FC<StatusToastProps> = (props) => {
  const isParticipanteEscriturador =
      useSelector((state: RootState) => state.auth.usuario.participante.funcao) === FuncaoParticipante.Escriturador;
  const classes = useStyles(props.status)();
  const icons: { [key: string]: JSX.Element } = {
    [RegistroStatus.Aprovado]: <CheckCircleIcon style={{ marginRight: 10 }} />,
    [RegistroStatus.Reprovado]: <CancelIcon style={{ marginRight: 10 }} />,
    [RegistroStatus.AguardandoCorrecao]: <WatchLaterIcon style={{ marginRight: 10 }} />,
    [RegistroStatus.Excluido]: <CancelIcon style={{ marginRight: 10 }} />,
    [RegistroStatus.AguardandoAprovacaoEdicao]: <WatchLaterIcon style={{ marginRight: 10 }} />,
  };
  const descriptions: { [key: string]: string } = {
    [RegistroStatus.Aprovado]: isParticipanteEscriturador ? 'Emissão aprovada pelo escriturador.' : 'aprovado com sucesso.',
    [RegistroStatus.Reprovado]: isParticipanteEscriturador ? 'Emissão reprovada pelo escriturador.' : 'reprovado com sucesso.',
    [RegistroStatus.AguardandoCorrecao]: 'reprovado com pendências.',
    [RegistroStatus.Excluido]: 'excluído com sucesso.',
    [RegistroStatus.AguardandoAprovacaoEdicao]: 'editado com sucesso.',
  };
  return (
    <div className={classes.toast}>
      {icons[props.status]}
      <div style={{ display: 'flex', flex: 1 }}>
        {isParticipanteEscriturador ? (
          <Typography variant="body2">{descriptions[props.status]}</Typography>
        ) : (
          <>
            <Typography variant="body2">{'Cadastro'}</Typography>&nbsp;<Typography>{props.ticket}</Typography>
            &nbsp;<Typography variant="body2">{descriptions[props.status] ?? ''}</Typography>
          </>
        )}
      </div>
      <IconButton onClick={props.onDismiss}>
        <CloseIcon />
      </IconButton>
    </div>
  );
};
